(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["retaily-product-details"] && !Shopify.designMode) return;
  try {
    if (!window.__retailyCollapsibleBound) {
    window.__retailyCollapsibleBound = true;
    // Document-level delegation survives Shopify section morphing.
    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-retaily-collapse-toggle]');
      if (!toggle) return;
      const wrap = toggle.closest('[data-retaily-collapsible]');
      if (wrap) wrap.classList.toggle('is-open');
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["retaily-stock-shipping"] && !Shopify.designMode) return;
  try {
    (() => {
    function formatDate(date) {
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    }

    function addBusinessDays(startDate, businessDays) {
      // Adds N business days (Mon–Fri), skipping weekends.
      const result = new Date(startDate);
      let added = 0;
      while (added < businessDays) {
        result.setDate(result.getDate() + 1);
        const day = result.getDay();
        if (day !== 0 && day !== 6) added++;
      }
      return result;
    }

    function renderRanges(root) {
      (root || document).querySelectorAll('.retaily-delivery-range').forEach((element) => {
        const minDays = parseInt(element.dataset.minDays, 10);
        const maxDays = parseInt(element.dataset.maxDays, 10);
        if (Number.isNaN(minDays) || Number.isNaN(maxDays)) return;
        const now = new Date();
        element.textContent = formatDate(addBusinessDays(now, minDays)) + ' – ' + formatDate(addBusinessDays(now, maxDays));
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => renderRanges());
    } else {
      renderRanges();
    }
    document.addEventListener('shopify:section:load', (e) => renderRanges(e.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
